import { useState } from "react";
import { supabase } from "./supabase";
import stadiumImg from "./stadium.png";

export default function EnrollPlayer({ onBack, academy }) {
  const [form, setForm] = useState({
    name: "",
    parent_name: "",
    whatsapp: "",
    batch: "",
    fee_amount: "",
    joined_date: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [focused, setFocused] = useState("");
  const [duplicate, setDuplicate] = useState(null);
  const [phoneError, setPhoneError] = useState("");
  const [phoneValid, setPhoneValid] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
    const formatted = digits.length > 5
      ? `${digits.slice(0, 5)} ${digits.slice(5)}`
      : digits;
    setForm({ ...form, whatsapp: formatted });
    if (digits.length === 0) {
      setPhoneError(""); setPhoneValid(false);
    } else if (!/^[6-9]/.test(digits)) {
      setPhoneError("Must start with 6, 7, 8 or 9"); setPhoneValid(false);
    } else if (digits.length < 10) {
      setPhoneError("Enter a valid 10-digit number"); setPhoneValid(false);
    } else {
      setPhoneError(""); setPhoneValid(true);
    }
  };

  const generateStudentId = () => {
    const num = Math.floor(1000 + Math.random() * 9000);
    return `TCR-${num}`;
  };

  const checkDuplicate = async (name) => {
    if (name.length < 3) { setDuplicate(null); return; }
    const { data } = await supabase
      .from("players")
      .select("name, batch, student_id")
      .ilike("name", `%${name}%`);
    if (data && data.length > 0) {
      setDuplicate(data[0]);
    } else {
      setDuplicate(null);
    }
  };

  const handleSubmit = async () => {
    if (!form.name) return alert("Player name is required");
    if (form.whatsapp && !phoneValid) return alert("Please enter a valid WhatsApp number");
    setLoading(true);
    const student_id = generateStudentId();
    const { data: { user } } = await supabase.auth.getUser();
    const { error } = await supabase
      .from("players")
      .insert([{ ...form, student_id, fee_amount: Number(form.fee_amount), user_id: user.id }]);

    if (error) {
      alert("Error: " + error.message);
    } else {
      setSuccess(true);
      setForm({
        name: "",
        parent_name: "",
        whatsapp: "",
        batch: "",
        fee_amount: "",
        joined_date: "",
      });
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.header}>
            <div style={styles.logoRow}>
              <div style={styles.logoIcon}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#d4a017" strokeWidth="1.5"/>
                  <path d="M8 12l3 3 5-5" stroke="#d4a017" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span style={styles.logoText}>{academy?.name?.toUpperCase() || "THE COACH ROOM"}</span>
            </div>
          </div>
          <div style={styles.successScreen}>
            <div style={styles.successIcon}>
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="11" stroke="#d4a017" strokeWidth="1.5"/>
                <path d="M7 12l4 4 6-7" stroke="#d4a017" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 style={styles.successTitle}>Player Enrolled</h2>
            <p style={styles.successSub}>Student has been added to your academy successfully.</p>
            <button style={styles.successBtn} onClick={() => setSuccess(false)}>
              Enroll Another Player
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.logoRow}>
            {onBack && (
              <button onClick={onBack} style={styles.backBtn}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M19 12H5M12 19l-7-7 7-7" stroke="#d4a017" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
            <div style={styles.logoIcon}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#d4a017" strokeWidth="1.5" strokeLinejoin="round"/>
                <path d="M2 17l10 5 10-5" stroke="#d4a017" strokeWidth="1.5" strokeLinejoin="round"/>
                <path d="M2 12l10 5 10-5" stroke="#d4a017" strokeWidth="1.5" strokeLinejoin="round"/>
              </svg>
            </div>
            <span style={styles.logoText}>{academy?.name?.toUpperCase() || "THE COACH ROOM"}</span>
          </div>
          <div style={styles.headerBottom}>
            <h2 style={styles.headerTitle}>Enroll New Player</h2>
            <span style={styles.headerTag}>Academy Management</span>
          </div>
        </div>

        {/* PROGRESS BAR */}
        <div style={styles.progressBar}>
          <div style={styles.progressFill}></div>
        </div>

        {/* FORM */}
        <div style={styles.form}>

          {/* PLAYER NAME */}
          <div style={styles.field}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/>
                  <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              Player Name <span style={styles.required}>*</span>
            </label>
            <input
              style={{
                ...styles.input,
                borderColor: focused === "name" ? "#d4a017" : "#e8e0d0",
                boxShadow: focused === "name" ? "0 0 0 3px rgba(212,160,23,0.1)" : "none",
              }}
              name="name"
              placeholder="e.g. Arjun Mehta"
              value={form.name}
              onChange={(e) => {
                handleChange(e);
                checkDuplicate(e.target.value);
              }}
              onFocus={() => setFocused("name")}
              onBlur={() => setFocused("")}
            />
            {duplicate && (
              <div style={styles.duplicateWarning}>
                ⚠️ Similar player found — <strong>{duplicate.name}</strong> ({duplicate.batch} · {duplicate.student_id}). Are you sure this is a different student?
              </div>
            )}
          </div>

          {/* PARENT NAME */}
          <div style={styles.field}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/>
                  <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              Parent Name
            </label>
            <input
              style={{
                ...styles.input,
                borderColor: focused === "parent_name" ? "#d4a017" : "#e8e0d0",
                boxShadow: focused === "parent_name" ? "0 0 0 3px rgba(212,160,23,0.1)" : "none",
              }}
              name="parent_name"
              placeholder="e.g. Rajesh Mehta"
              value={form.parent_name}
              onChange={handleChange}
              onFocus={() => setFocused("parent_name")}
              onBlur={() => setFocused("")}
            />
          </div>

          {/* WHATSAPP */}
          <div style={styles.field}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.07 1.18 2 2 0 012.07 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </span>
              WhatsApp Number
            </label>
            <div style={{
              ...styles.inputWrapper,
              borderColor: phoneError ? "#e53e3e" : phoneValid ? "#38a169" : focused === "whatsapp" ? "#d4a017" : "#e8e0d0",
              boxShadow: phoneError ? "0 0 0 3px rgba(229,62,62,0.1)" : phoneValid ? "0 0 0 3px rgba(56,161,105,0.1)" : focused === "whatsapp" ? "0 0 0 3px rgba(212,160,23,0.1)" : "none",
            }}>
              <span style={styles.inputPrefix}>+91</span>
              <input
                style={styles.inputWithPrefix}
                name="whatsapp"
                placeholder="98765 43210"
                value={form.whatsapp}
                onChange={handlePhoneChange}
                onFocus={() => setFocused("whatsapp")}
                onBlur={() => setFocused("")}
              />
              {phoneValid && (
                <span style={styles.phoneValid}>✓</span>
              )}
            </div>
            {phoneError && (
              <div style={styles.phoneError}>{phoneError}</div>
            )}
          </div>

          {/* BATCH */}
          <div style={styles.field}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              Batch
            </label>
            <div style={styles.batchGrid}>
              {["Morning", "Evening", "Weekend", "U-14", "U-19"].map((b) => (
                <button
                  key={b}
                  style={{
                    ...styles.batchBtn,
                    background: form.batch === b ? "#1a3a1b" : "white",
                    color: form.batch === b ? "#d4a017" : "#4a5568",
                    border: form.batch === b ? "1.5px solid #1a3a1b" : "1.5px solid #e8e0d0",
                    fontWeight: form.batch === b ? "700" : "500",
                  }}
                  onClick={() => setForm({ ...form, batch: b })}
                >
                  {b}
                </button>
              ))}
            </div>
          </div>

          {/* FEE + DATE ROW */}
          <div style={styles.row}>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>₹</span>
                Monthly Fee
              </label>
              <div style={{
                ...styles.inputWrapper,
                borderColor: focused === "fee_amount" ? "#d4a017" : "#e8e0d0",
                boxShadow: focused === "fee_amount" ? "0 0 0 3px rgba(212,160,23,0.1)" : "none",
              }}>
                <span style={styles.inputPrefix}>₹</span>
                <input
                  style={styles.inputWithPrefix}
                  name="fee_amount"
                  type="number"
                  placeholder="1500"
                  value={form.fee_amount}
                  onChange={handleChange}
                  onFocus={() => setFocused("fee_amount")}
                  onBlur={() => setFocused("")}
                />
              </div>
            </div>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </span>
                Date Joined
              </label>
              <input
                style={{
                  ...styles.input,
                  borderColor: focused === "joined_date" ? "#d4a017" : "#e8e0d0",
                  boxShadow: focused === "joined_date" ? "0 0 0 3px rgba(212,160,23,0.1)" : "none",
                }}
                name="joined_date"
                type="date"
                value={form.joined_date}
                onChange={handleChange}
                onFocus={() => setFocused("joined_date")}
                onBlur={() => setFocused("")}
              />
            </div>
          </div>

          {/* SUBMIT */}
          <button
            style={loading ? styles.btnDisabled : styles.btn}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <span>Enrolling...</span>
            ) : (
              <span style={styles.btnInner}>
                Enroll Player
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            )}
          </button>

          <p style={styles.formNote}>
            A unique Student ID (TCR-XXXX) will be auto-generated on enrollment.
          </p>

        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f1f14 0%, #1a3a1b 50%, #0f1f14 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem 1rem",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    boxSizing: "border-box",
  },
  card: {
    background: "#faf7f0",
    width: "100%",
    maxWidth: "460px",
    boxShadow: "0 24px 64px rgba(0,0,0,0.4), 0 0 0 1px rgba(212,160,23,0.2)",
    overflow: "hidden",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  header: {
    background: `linear-gradient(
      to bottom,
      rgba(0,0,0,0.2) 0%,
      rgba(10,20,10,0.85) 65%,
      rgba(250,247,240,1) 100%
    ), url(${stadiumImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center 30%",
    padding: "2rem 1.8rem 3rem",
    boxSizing: "border-box",
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    marginBottom: "1.8rem",
  },
  backBtn: {
    background: "rgba(212,160,23,0.1)",
    border: "1px solid rgba(212,160,23,0.3)",
    borderRadius: "8px",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    padding: 0,
  },
  logoIcon: {
    width: "36px",
    height: "36px",
    background: "rgba(212,160,23,0.15)",
    border: "1px solid rgba(212,160,23,0.4)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  logoText: {
    color: "white",
    fontSize: "0.75rem",
    fontWeight: "800",
    letterSpacing: "3px",
  },
  headerBottom: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "1rem",
  },
  headerTitle: {
    color: "white",
    fontSize: "1.4rem",
    fontWeight: "700",
    margin: 0,
    letterSpacing: "-0.3px",
  },
  headerTag: {
    background: "rgba(212,160,23,0.15)",
    border: "1px solid rgba(212,160,23,0.5)",
    color: "#d4a017",
    fontSize: "0.6rem",
    fontWeight: "700",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    padding: "0.3rem 0.7rem",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  progressBar: {
    height: "3px",
    background: "#e8e0d0",
  },
  progressFill: {
    height: "100%",
    width: "30%",
    background: "linear-gradient(90deg, #1a3a1b, #d4a017)",
  },
  form: {
    padding: "1.6rem 1.8rem 2rem",
    boxSizing: "border-box",
    width: "100%",
  },
  row: {
    display: "flex",
    gap: "1rem",
  },
  field: {
    marginBottom: "1.2rem",
    width: "100%",
    boxSizing: "border-box",
  },
  label: {
    display: "flex",
    alignItems: "center",
    gap: "0.35rem",
    fontSize: "0.7rem",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: "#4a5568",
    marginBottom: "0.45rem",
  },
  labelIcon: {
    color: "#1a3a1b",
    display: "flex",
    alignItems: "center",
    fontSize: "0.75rem",
    fontWeight: "800",
  },
  required: {
    color: "#d4a017",
    fontSize: "0.8rem",
  },
  inputWrapper: {
    display: "flex",
    alignItems: "stretch",
    border: "1.5px solid #e8e0d0",
    background: "white",
    transition: "border-color 0.15s, box-shadow 0.15s",
    boxSizing: "border-box",
    width: "100%",
  },
  inputPrefix: {
    padding: "0 0.8rem",
    fontSize: "0.82rem",
    fontWeight: "700",
    color: "#1a3a1b",
    borderRight: "1.5px solid #e8e0d0",
    display: "flex",
    alignItems: "center",
    background: "#f5f0e8",
    flexShrink: 0,
  },
  input: {
    width: "100%",
    padding: "0.75rem 0.9rem",
    border: "1.5px solid #e8e0d0",
    fontSize: "0.9rem",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    outline: "none",
    background: "white",
    color: "#1a1a1a",
    transition: "border-color 0.15s, box-shadow 0.15s",
    borderRadius: "0",
    boxSizing: "border-box",
  },
  inputWithPrefix: {
    flex: 1,
    padding: "0.75rem 0.9rem",
    border: "none",
    fontSize: "0.9rem",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    outline: "none",
    background: "white",
    color: "#1a1a1a",
    width: "100%",
    boxSizing: "border-box",
  },
  batchGrid: {
    display: "flex",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  batchBtn: {
    padding: "0.5rem 1rem",
    fontSize: "0.82rem",
    cursor: "pointer",
    transition: "all 0.15s",
    letterSpacing: "0.3px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    borderRadius: "0",
  },
  btn: {
    width: "100%",
    padding: "0.95rem",
    background: "#1a3a1b",
    color: "white",
    border: "none",
    fontSize: "0.9rem",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "0.8rem",
    letterSpacing: "0.5px",
    transition: "background 0.2s",
    boxSizing: "border-box",
  },
  btnInner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
  },
  btnDisabled: {
    width: "100%",
    padding: "0.95rem",
    background: "#a0aec0",
    color: "white",
    border: "none",
    fontSize: "0.9rem",
    fontWeight: "700",
    cursor: "not-allowed",
    marginTop: "0.8rem",
    boxSizing: "border-box",
  },
  formNote: {
    textAlign: "center",
    fontSize: "0.72rem",
    color: "#a0aec0",
    marginTop: "0.8rem",
    fontStyle: "italic",
  },
  successScreen: {
    padding: "3rem 2rem",
    textAlign: "center",
  },
  successIcon: {
    margin: "0 auto 1.5rem",
    width: "fit-content",
  },
  successTitle: {
    fontWeight: "800",
    fontSize: "1.4rem",
    color: "#1a3a1b",
    margin: "0 0 0.5rem",
  },
  successSub: {
    color: "#6b7280",
    fontSize: "0.88rem",
    marginBottom: "2rem",
    lineHeight: "1.6",
  },
  successBtn: {
    background: "#1a3a1b",
    color: "#d4a017",
    border: "none",
    padding: "0.9rem 2rem",
    fontSize: "0.88rem",
    fontWeight: "700",
    cursor: "pointer",
    letterSpacing: "0.5px",
  },
  duplicateWarning: {
    background: "#fff8e1",
    border: "1.5px solid #d4a017",
    color: "#7a5c00",
    padding: "0.7rem 0.9rem",
    fontSize: "0.8rem",
    lineHeight: "1.5",
    marginTop: "0.4rem",
    boxSizing: "border-box",
  },
  phoneError: {
    color: "#e53e3e",
    fontSize: "0.75rem",
    fontWeight: "600",
    marginTop: "0.35rem",
    display: "flex",
    alignItems: "center",
    gap: "0.3rem",
  },
  phoneValid: {
    color: "#38a169",
    fontWeight: "800",
    fontSize: "1rem",
    padding: "0 0.8rem",
    display: "flex",
    alignItems: "center",
  },
};